<template>
  <div class="features-page">
    <!-- Hero Section -->
    <section class="hero">
      <div class="container">
        <h1 class="hero-title">Comprehensive Features for Modern Club Management</h1>
        <p class="hero-subtitle">
          Discover how eClub transforms the way schools manage extracurricular activities
        </p>
      </div>
    </section>

    <!-- Core Features -->
    <section class="core-features">
      <div class="container">
        <h2 class="section-title">Core Features</h2>
        <div class="features-grid">
          
          <!-- My Clubs Feature -->
          <div class="feature-detail">
            <div class="feature-header">
              <div class="feature-icon">📋</div>
              <h3>My Clubs Dashboard</h3>
            </div>
            <p class="feature-description">
              A comprehensive dashboard for student accounts featuring an aggregated Discussion section 
              that consolidates the latest discussions from all clubs a student is a member of.
            </p>
            <ul class="feature-benefits">
              <li>Single location to view all club updates</li>
              <li>Direct engagement without navigating to individual clubs</li>
              <li>Streamlined access to discussions via "View" option</li>
              <li>Real-time updates from all joined clubs</li>
            </ul>
          </div>

          <!-- Discussion Feature -->
          <div class="feature-detail">
            <div class="feature-header">
              <div class="feature-icon">💬</div>
              <h3>Discussion Forums</h3>
            </div>
            <p class="feature-description">
              Organized conversations with focused topics, allowing clubs to maintain dedicated 
              threads without the distractions of general chat.
            </p>
            <ul class="feature-benefits">
              <li>Topic-specific discussion threads</li>
              <li>Planning outings and recruitment</li>
              <li>Focused and traceable conversations</li>
              <li>Club-specific communication spaces</li>
            </ul>
          </div>

          <!-- Todo Feature -->
          <div class="feature-detail">
            <div class="feature-header">
              <div class="feature-icon">✅</div>
              <h3>Task Management</h3>
            </div>
            <p class="feature-description">
              Streamlined todo features that allow clubs to create lists, assign responsibilities, 
              and set deadlines for effective project management.
            </p>
            <ul class="feature-benefits">
              <li>Create and manage task lists</li>
              <li>Assign responsibilities to members</li>
              <li>Set and track deadlines</li>
              <li>Monitor progress and completion</li>
            </ul>
          </div>

          <!-- eBooks Feature -->
          <div class="feature-detail">
            <div class="feature-header">
              <div class="feature-icon">📚</div>
              <h3>Interactive eBooks</h3>
            </div>
            <p class="feature-description">
              Card-based learning approach with interactive elements, quizzes, and feedback 
              that promotes self-directed learning and active engagement.
            </p>
            <ul class="feature-benefits">
              <li>Bite-sized knowledge points for easy digestion</li>
              <li>Interactive quizzes and feedback</li>
              <li>Thematically organized content</li>
              <li>Compact, efficient learning experience</li>
            </ul>
          </div>

        </div>
      </div>
    </section>

    <!-- Administrative Features -->
    <section class="admin-features">
      <div class="container">
        <h2 class="section-title">Administrative Tools</h2>
        <div class="admin-grid">
          
          <div class="admin-card">
            <h3>School Adviser Management</h3>
            <p>
              Optimized functionality for School Admins to allocate clubs to teachers with 
              comprehensive overview and management capabilities.
            </p>
            <ul>
              <li>Overview of clubs managed by each adviser</li>
              <li>Detailed list of clubs under management</li>
              <li>Direct removal of clubs from adviser management</li>
              <li>Streamlined administrative processes</li>
            </ul>
          </div>

          <div class="admin-card">
            <h3>Global Club Analytics</h3>
            <p>
              Access comprehensive dashboard featuring school club statistics, rankings, 
              and performance metrics for data-driven decision making.
            </p>
            <ul>
              <li>School club statistics and metrics</li>
              <li>Club activities and achievements display</li>
              <li>Global club rankings and best practices</li>
              <li>Annual report generation and review</li>
            </ul>
          </div>

          <div class="admin-card">
            <h3>Club Organization</h3>
            <p>
              Comprehensive tools for managing club organization, staffing, and 
              accessing extensive libraries of activities and resources.
            </p>
            <ul>
              <li>Club staffing and organization management</li>
              <li>Comprehensive activity and resource library</li>
              <li>Club course and activity assignment</li>
              <li>Performance monitoring and evaluation</li>
            </ul>
          </div>

        </div>
      </div>
    </section>

    <!-- Technical Features -->
    <!-- <section class="technical-features">
      <div class="container">
        <h2 class="section-title">Technical Excellence</h2>
        <div class="tech-grid">
          
          <div class="tech-item">
            <div class="tech-icon">🔒</div>
            <h3>Secure & Reliable</h3>
            <p>Enterprise-grade security with data protection and reliable uptime for continuous access.</p>
          </div>

          <div class="tech-item">
            <div class="tech-icon">📱</div>
            <h3>Mobile Responsive</h3>
            <p>Fully responsive design ensuring seamless experience across all devices and screen sizes.</p>
          </div>

          <div class="tech-item">
            <div class="tech-icon">⚡</div>
            <h3>Fast Performance</h3>
            <p>Optimized for speed with quick loading times and smooth interactions for better user experience.</p>
          </div>

          <div class="tech-item">
            <div class="tech-icon">🌐</div>
            <h3>Cloud-Based</h3>
            <p>Cloud infrastructure ensuring scalability, automatic updates, and accessible from anywhere.</p>
          </div>

        </div>
      </div>
    </section> -->

    <!-- CTA Section -->
    <section class="cta">
      <div class="container">
        <div class="cta-content">
          <h2>Experience These Features Today</h2>
          <p>Join the growing community of schools transforming their club management with eClub.</p>
          <router-link to="/login" class="btn btn-primary">Start Your Free Trial</router-link>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'OfficialFeatures'
}
</script>

<style scoped lang="scss">
.features-page {
  .hero {
    background: linear-gradient(135deg, #fff5f3 0%, #ffe6e3 100%);
    padding: 80px 0 60px;
    text-align: center;
    
    .hero-title {
      font-size: 3rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 20px;
      line-height: 1.2;
    }
    
    .hero-subtitle {
      font-size: 1.3rem;
      color: #666;
      max-width: 600px;
      margin: 0 auto;
    }
  }
  
  .core-features {
    padding: 80px 0;
    background: white;

    .section-title {
      text-align: center !important;
      width: 100%;
      display: block;
      margin: 0 auto 20px;
    }
    
    .features-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
      gap: 50px;
      margin-top: 50px;
    }
    
    .feature-detail {
      padding: 40px;
      border-radius: 20px;
      background: #f8f9fa;
      border: 1px solid #e9ecef;
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        border-color: #FF6B4A;
      }
      
      .feature-header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        
        .feature-icon {
          font-size: 2.5rem;
          margin-right: 15px;
        }
        
        h3 {
          color: #1a1a1a;
          font-size: 1.8rem;
          font-weight: 600;
          margin: 0;
        }
      }
      
      .feature-description {
        color: #666;
        font-size: 1.1rem;
        line-height: 1.6;
        margin-bottom: 25px;
      }
      
      .feature-benefits {
        list-style: none;
        padding: 0;
        margin: 0;
        
        li {
          color: #555;
          margin-bottom: 10px;
          padding-left: 25px;
          position: relative;
          
          &::before {
            content: '✓';
            color: #FF6B4A;
            font-weight: bold;
            position: absolute;
            left: 0;
            font-size: 1.2rem;
          }
        }
      }
    }
  }
  
  .admin-features {
    padding: 80px 0;
    background: #f8f9fa;

    .section-title {
      text-align: center !important;
      width: 100%;
      display: block;
      margin: 0 auto 20px;
    }
    
    .admin-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
      gap: 40px;
      margin-top: 50px;
    }
    
    .admin-card {
      background: white;
      padding: 40px 30px;
      border-radius: 15px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
      transition: transform 0.3s ease;
      
      &:hover {
        transform: translateY(-5px);
      }
      
      h3 {
        color: #FF6B4A;
        font-size: 1.6rem;
        margin-bottom: 15px;
        font-weight: 600;
      }
      
      p {
        color: #666;
        line-height: 1.6;
        margin-bottom: 20px;
      }
      
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        
        li {
          color: #555;
          margin-bottom: 8px;
          padding-left: 20px;
          position: relative;
          font-size: 0.95rem;
          
          &::before {
            content: '•';
            color: #FF6B4A;
            position: absolute;
            left: 0;
            font-size: 1.2rem;
          }
        }
      }
    }
  }
  
  .technical-features {
    padding: 80px 0;
    background: white;

    .section-title {
      text-align: center !important;
      width: 100%;
      display: block;
      margin: 0 auto 20px;
    }
    
    .tech-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 40px;
      margin-top: 50px;
    }
    
    .tech-item {
      text-align: center;
      padding: 30px 20px;
      
      .tech-icon {
        font-size: 3rem;
        margin-bottom: 20px;
      }
      
      h3 {
        color: #1a1a1a;
        font-size: 1.4rem;
        margin-bottom: 15px;
        font-weight: 600;
      }
      
      p {
        color: #666;
        line-height: 1.6;
      }
    }
  }
  
  .cta {
    background: linear-gradient(135deg, #FF6B4A 0%, #ff8a6b 100%);
    padding: 80px 0;
    text-align: center;
    
    .cta-content {
      max-width: 600px;
      margin: 0 auto;
      
      h2 {
        color: white;
        font-size: 2.5rem;
        margin-bottom: 20px;
        font-weight: 600;
      }
      
      p {
        color: rgba(255, 255, 255, 0.9);
        font-size: 1.2rem;
        margin-bottom: 30px;
      }
    }
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 20px;
}

.btn {
  display: inline-block;
  padding: 20px 40px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  
  &.btn-primary {
    background: white;
    color: #FF6B4A;
    
    &:hover {
      background: #f8f9fa;
      transform: translateY(-2px);
    }
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2.2rem;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
  }
  
  .admin-grid, .tech-grid {
    grid-template-columns: 1fr;
  }
  
  .section-title {
    font-size: 2rem;
  }
}
</style>